import { IconButton, Typography, InputBase } from "@mui/material";

import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import { getFromLocalStorage } from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import * as CONSTANT from "../../constants/Constant";

import {
  globalSearchText,
  selectedItems,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  PROCESSING_PLEASE_WAIT,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
} from "../../constants/Strings";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import {
  addFreezeAccount,
  getCompanyDetails,
  updateFreezeAccountDetails,
} from "../../services/ApiService";
import { useLocation, useNavigate } from "react-router-dom";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import SearchIcon from "@mui/icons-material/Search";
import ToolbarFilterButton from "../../components/ToolbarFilterButton";
import DatePickerDialog from "../../components/DatePickerDialog";
import CustomButtonSmall from "../../components/CustomButtonSmall";
import { addCompanyFilterItems } from "../../data/freezeFilterItems";
import { CustomToolbarWithoutExport } from "../../components/DataGridCustomToolBarWithoutExport";
import AddDealerFreezeAccountDialog from "../freezeAccount/AddDealerFreezeAccountDialog";
import AddFreezeAccountDialog from "../freezeAccount/AddFreezeAccountDialog";

export function SearchAndSelectCompanyDetails() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  // Retrieve location state
  const location = useLocation();
  const dataProps = location.state && location.state.data;
  const flowProp = location.state && location.state.type;
  const isNetworkConnectionAvailable = UseOnlineStatus();

  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  // filterCriteria is fetched from API and has the structure of [{ "displayName": "NAME", "paramName": "accountName" }]
  const [filter, setFilter] = useState("");
  const [filterCriteria, setFilterCriteria] = useState([
    { keyValue: "", displayName: "", paramName: "" },
  ]);
  const [filterDisplayOptions, setFilterDisplayOptions] = useState([]);
  const [defaultFilter, setDefaultFilter] = useState("Name");

  const [gridHeight, setGridHeight] = useState(108); // Default height

  const [currentPage, setCurrentPage] = useState(0);

  //const [open, setOpen] = useState(false);
  const [accountDetailsToAdd, setAccountDetailsToAdd] = useState([]);
  const [searchInitiated, setSearchInitiated] = useState(false);

  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);

  const [openSaveAndRemoveDialog, setOpenSaveAndRemoveDialog] = useState(false);
  const [openAddFreezeAccountDialog, setOpenAddFreezeAccountDialog] =
    useState(false);

  // const [selectedDealerName, setSelectedDealerName] = useState("");
  // const [selectedDealerCode, setSelectedDealerCode] = useState("");

  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  const [paginationModel, setPaginationModel] = useState({
    pageSize: 25,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(25);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [searchQueryPlaceholder, setSearchQueryPlaceholder] =
    useState("Search Name");
  const [searchQuery, setSearchQuery] = useAtom(globalSearchText);

  const [searchDealerQuery, setDealerSearchQuery] =  useAtom(globalSearchText); //useState(""); 

 // const classes = useStyles();
 const [formData, setFormData] = useState({
  reportType: "",
    subType: "",
    companyName: "",
    branch: "",
    addFilter: "",
    text: "",
    selectedDateDropdown: "",
    month: "",
    year: "",
    transactionType: "",
    addMoreFilter: "",
    date: "",
});








  useEffect(() => {

    DebugLog(
      "dataProps from Reports  " + JSON.stringify(dataProps)
    );
    setDealerSearchQuery("")
    setFormData(dataProps)

    setFilterCriteria(addCompanyFilterItems.result);
    setFilterDisplayOptions(
      addCompanyFilterItems.result.map((item) => item.displayName)
    );
    setDefaultFilter(addCompanyFilterItems.result[0].displayName);
    setFilter(addCompanyFilterItems.result[0]);

  }, []);
 
  useEffect(() => {

    const placeholder = "Search " + filter.displayName;
    setSearchQueryPlaceholder(placeholder);
    // setSearchQuery("");
  }, [filter]);

 

  useEffect(() => {

   
    setDefaultFilter("companyName");

    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, totalNoOfRows]);



  function requestUnFreezeAccountDetailsData(params, updatedValue) {
    setOpenSaveAndRemoveDialog(false);
    setOpenAddFreezeAccountDialog(false);
  }


  const freezeButton = (rowData) => {
    return (
      <CustomButtonSmall
        btnBG={colors.primary[100]}
        btnColor={colors.grey[900]}
        btnTxt={"ADD COMPANY"}
        btnBorder={"1px solid" + colors.primary[100]}
        onClick={() => handleAddCompanyAccountClick(rowData)}
      ></CustomButtonSmall>
    );
  };

 

  const handleAddCompanyAccountClick = (params) => {
    let value = {};


    // reportType: formData.reportType!==null ? formData.reportType : "",
    // subType:formData.subType!==null ? formData.subType : "",
    // companyName: params.companyName!==null ? params.companyName : "",
    // branch: formData.branch!==null ? formData.branch : "",
    // addFilter: formData.addFilter!==null ? formData.addFilter : "",
    // addMoreFilter: formData.addMoreFilter!==null ? formData.addMoreFilter : "",
    // selectedDateDropdown: formData.selectedDateDropdown!==null ? formData.selectedDateDropdown : "",
    // selectedMonth: formData.selectedMonth!==null ? formData.selectedMonth : "",
    // selectedMonthYear: formData.selectedMonthYear!==null ? formData.selectedMonthYear : "",


    value = {
      reportType: "",
    subType: "",
    companyName: params.companyName!==null ? params.companyName : "",
    branch: "",
    addFilter: "",
    text: "",
    selectedDateDropdown: "",
    month: "",
    year: "",
    transactionType: "",
    addMoreFilter: "",
    date:""
     
    }

    
    setFormData(value);
    DebugLog(
      "value data  " + JSON.stringify(value)
    );

    navigate(CONSTANT.REPORTS_FILTER_ROUTE, {
            state: { data: value, dealerDetails:params, type: 0 },
          });
       // setSelectedItem(rowData);
       // setOpenSaveAndRemoveDialog(true);
  };

  const handleFilterChange = (filter) => {
    // find the right filterCriteria based on the selected filter
    const selectedFilter = filterCriteria.find(
      (item) => item.displayName === filter
    );
    setFilter(selectedFilter);
  };


  const handleAddDealerStatusCloseDialog = () => {
    setOpenSaveAndRemoveDialog(false);
    setOpenAddFreezeAccountDialog(false);
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);

    //DateCalendarReferenceDate()
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 65; // Height of each data row
    let rowCount = 0;
    if (rowsPerPage <= paginationModel.pageSize) {
      rowCount = rowsPerPage; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }
    const totalHeight = headerHeight + (rowCount + 1) * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }


  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    // Avoid using state directly for API call as the state update function is async.
    // Means it will not update the state immediately and it will be using the old state value.
    searchFreezeAccountDetails(newPage, paginationModel.pageSize);
  };


  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });

    searchFreezeAccountDetails(newPage, paginationModel.pageSize);
  };
  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0.
    searchFreezeAccountDetails(0, newPageSize);
  };


 
  // get result from search query button update
  function addDealerSearchButtonClicked() {
    if (searchDealerQuery === "") {
      alert("Please enter some value!");
    } else if (filter === "") {
      searchFreezeAccountDetails(
        paginationModel.page,
        paginationModel.pageSize
      );

      //getFreezeAccountDetailsToAdd(searchDealerQuery, "Company Name");
    } else {
      searchFreezeAccountDetails(
        paginationModel.page,
        paginationModel.pageSize
      );

      //getFreezeAccountDetailsToAdd(searchDealerQuery, filter);
    }
  }
  // Create Request Object for searchFreezeAccountDetails API
  function createRequestObject(
    pageNumber,
    pageSize,
    selectedFilter,
    filterValue
  ) {
    // Initialize all fields to null
    let requestObject = {
      companyName: null,
      companyCode: null,
      companyId: null,
    };

    // Set the appropriate field based on filterCriteria
    if (
      selectedFilter != null &&
      selectedFilter != undefined &&
      selectedFilter.paramName != ""
    ) {
      requestObject[selectedFilter.paramName] = filterValue;
    }

    return requestObject;
  }
  // search accounts after user click search button
  function searchFreezeAccountDetails(pageNumber, pageSize) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = createRequestObject(
          pageNumber,
          pageSize,
          filter,
          searchDealerQuery
        );
        // const requestObject = {
        //     pageNumber:pageNumber,
        //     pageSize:pageSize,
        // };
          
          

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_COMPANY_DETAILS_LIST
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };
          // response.data.result.accountList
          getCompanyDetails(requestData)
            .then((response) => {

              
              const contentData = response.data.result.companyAndBranchPage.content.map(
                (row) => ({
                  ...row,
                  id: generateRandomId(),
                })
              );
              setAccountDetailsToAdd(contentData);
              setRowsPerPage(response.data.result.companyAndBranchPage.content.length);
             
              setTotalNoOfRows(response.data.result.companyAndBranchPage.content.length);
              setTotalNoOfPages(response.data.result.companyAndBranchPage.totalPages);

              setSearchInitiated(true);
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              }
              // else if (
              //   error.data.errorCode === ApiErrorCode.UNABLE_TO_PROCESS_ERROR
              // ) {
              //   try {
              //     navigate(CONSTANT.FINANCE_DASHBOARD);
              //   } catch (error) {
              //     DebugLog("error " + error);
              //   }
              // }
              else {
                const message =
                  error.data != null
                    ? error.data.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });

          setLoading(false);
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }
  // // data === null || data === undefined
  function requestUpdateFreezeAccountDetailsData(params, updatedValue) {
    if (
      params.status === null ||
      params.status === undefined ||
      params.status === ""
    ) {
      try {
        if (isNetworkConnectionAvailable) {
          setProgressbarText(PROCESSING_PLEASE_WAIT);
          setLoading(true);

          const requestObject = {
            accountName: updatedValue.company,
            accountCode: updatedValue.code,
            vendorCode: updatedValue.vendorCode,
            freezeReason: updatedValue.frozenReason,
            pic: updatedValue.pic,
            // actionStatus: "",
            bankAccountNumber: updatedValue.accountNo,
            bankName: updatedValue.bank,
          };

          initializeEncryption(
            requestObject,
            getFromLocalStorage(MESSAGE_KEY),
            ApiType.ADD_FREEZED_ACCOUNT
          ).then((encryptedContentData) => {
            const requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              loginUserName: getFromLocalStorage(USER_NAME),
              contentData: encryptedContentData,
            };

            addFreezeAccount(requestData)
              .then((response) => {
                addDealerSearchButtonClicked();
                setLoading(false);
                showErrorAlert(
                  "UPDATED",
                  "Freeze account details updated successfully."
                );
              })
              .catch((error) => {
                if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                  navigate(CONSTANT.LOGIN)
                }
               else 
                if (
                  error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
                ) {
                  try {
                    navigate("/");
                  } catch (error) {
                    DebugLog("error " + error);
                  }
                } else {
                  const message =
                    error.response != null
                      ? error.displayErrorMessage
                      : "Unknown";

                  if (message)
                    showErrorAlert(
                      error.message,
                      ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                    );
                }
              });
          });
        } else {
          showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
        }
      } catch (error) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    } else if (params.status === "Unfrozen") {
      try {
        if (isNetworkConnectionAvailable) {
          setProgressbarText(LOADING_PLEASE_WAIT);
          setLoading(true);

          const requestObject = {
            accountCode: updatedValue.code,
            actionStatus: "1",
            freezeReason: updatedValue.frozenReason,
          };

          initializeEncryption(
            requestObject,
            getFromLocalStorage(MESSAGE_KEY),
            ApiType.GET_EARMARKS_DETAILS
          ).then((encryptedContentData) => {
            const requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
              contentData: encryptedContentData,
            };

            updateFreezeAccountDetails(requestData)
              .then((response) => {
                addDealerSearchButtonClicked();
                setLoading(false);
                showErrorAlert("FREEZED", "Account Freezed successfully.");
              })
              .catch((error) => {
                if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                  navigate(CONSTANT.LOGIN)
                }
               else 
                if (
                  error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
                ) {
                  try {
                    navigate("/");
                  } catch (error) {
                    DebugLog("error " + error);
                  }
                } else {
                  const message =
                    error.response != null
                      ? error.displayErrorMessage
                      : "Unknown";

                  if (message)
                    showErrorAlert(
                      error.message,
                      ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                    );
                }
              });
          });
        } else {
          showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
        }
      } catch (error) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    } else if (params.status !== "Unfrozen") {
      try {
        if (isNetworkConnectionAvailable) {
          setProgressbarText(LOADING_PLEASE_WAIT);
          setLoading(true);

          const requestObject = {
            accountCode: params.accountCode,
            actionStatus: "1",
            unFreezeReason: updatedValue.frozenReason,
          };

          initializeEncryption(
            requestObject,
            getFromLocalStorage(MESSAGE_KEY),
            ApiType.GET_EARMARKS_DETAILS
          ).then((encryptedContentData) => {
            const requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              loginUserName: getFromLocalStorage(USER_NAME),
              contentData: encryptedContentData,
            };

            updateFreezeAccountDetails(requestData)
              .then((response) => {
                setLoading(false);
                showErrorAlert(
                  "UN-FREEZED",
                  "Account Un-Freezed successfully."
                );
                addDealerSearchButtonClicked();
              })
              .catch((error) => {
                if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                  navigate(CONSTANT.LOGIN)
                }
               else 
                if (
                  error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND
                ) {
                  try {
                    navigate("/");
                  } catch (error) {
                    DebugLog("error " + error);
                  }
                } else {
                  const message =
                    error.response != null
                      ? error.displayErrorMessage
                      : "Unknown";

                  if (message)
                    showErrorAlert(
                      error.message,
                      ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                    );
                }
              });
          });
        } else {
          showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
        }
      } catch (error) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    }
  }

  

//   const handleUnFreezeAccountClick = (rowData) => {
//     setSelectedItem(rowData);
//     setOpenAddFreezeAccountDialog(true);
//   };

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />

        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        <AddDealerFreezeAccountDialog
          open={openSaveAndRemoveDialog}
          onClose={handleAddDealerStatusCloseDialog}
          onDialogButtonClick={requestUpdateFreezeAccountDetailsData}
          onDialogRemoveButtonClick={requestUnFreezeAccountDetailsData}
          data={selectedItem}
        />

        <AddFreezeAccountDialog
          open={openAddFreezeAccountDialog}
          onClose={handleAddDealerStatusCloseDialog}
          onDialogButtonClick={requestUpdateFreezeAccountDetailsData}
          onDialogRemoveButtonClick={requestUnFreezeAccountDetailsData}
          data={selectedItem}
          screenType={1}
        />

        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Header */}
          <Grid
            container
            direction={"row"}
            alignItems={"center"}
            mb={2}
            ml={2}
            mt={1}
          >
            <Grid item mr={2}>
              <IconButton href={CONSTANT.REPORTS_FILTER_ROUTE} width={12}>
                <img src={"../../assets/common/Back.svg"} width={12} />
              </IconButton>
            </Grid>

            <Grid item>
              <Typography
                color={colors.grey[100]}
                fontWeight={"600"}
                variant="h3"
              >
                {"REPORTS"}
              </Typography>
            </Grid>

            <Box position="absolute" right={30} top={100}>
              <Grid container direction={"row"} alignItems={"center"}>
                {/* SEARCH BAR */}
                <Box
                  backgroundColor={colors.grey[900]}
                  borderRadius="20px"
                  ml={5}
                  mr={2}
                >
                  <InputBase
                    sx={{ ml: 2, flex: 1 }}
                    placeholder="Search Name"
                    value={searchDealerQuery}
                    onChange={(e) => setDealerSearchQuery(e.target.value)}
                  />

                  <IconButton type="button" sx={{ p: 1 }}>
                    <SearchIcon onClick={addDealerSearchButtonClicked} />
                  </IconButton>
                </Box>

                <ToolbarFilterButton
                  options={filterDisplayOptions}
                  defaultOption={defaultFilter}
                  onChange={handleFilterChange}
                  name={"FILTERS"}
                />

                {/* <ToolbarFilterButton
                  name={"FILTER"}
                  options={[
                    "Company Name",
                    "Dealer Code",
                    "Vendor Code",
                    "Status",
                    "Reason",
                  ]}
                  defaultOption={defaultFilter}
                  onChange={handleFilterChange}
                /> */}

                {/* <button onClick={handleOpenDialog}>Open Date Picker</button> */}
              </Grid>
            </Box>
          </Grid>

          <DatePickerDialog open={isDialogOpen} onClose={handleCloseDialog} />
          {/* Header */}

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            {!searchInitiated ? (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="450px"
                width="100%"
              >
                <Typography variant="h6" align="center">
                  Search results will be displayed here.
                </Typography>
              </Box>
            ) : accountDetailsToAdd.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  // rows={filteredRows.slice(
                  //   currentPage * pageSize,
                  //   (currentPage + 1) * pageSize
                  // )}
                  // columns={FreezeAccountAddDealerColumnHeader(freezeButton,unfreezeButton)}
                  // components={{ Toolbar: GridToolbar }}
                  // pageSize={pageSize}
                  // rowCount={filteredRows.length}
                  // pagination
                  // onPageChange={handlePageChange}

                  rows={accountDetailsToAdd}
                  columns={CompanyAndBranchPageColumnHeader(
                    freezeButton
                  )}
                  components={{ Toolbar: CustomToolbarWithoutExport }}
                  checkboxSelection={false}
                  selecion
                  pageSize={pageSize}
                  pageSizeOptions={[25, 50, 100]}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  // onRowClick={handleRowClick}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {accountDetailsToAdd.length > 0 ? (
            <Box>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}


// {
//     "companyId": "20749",
//     "companyName": "011 HS Mobile Services",
//     "companyCode": "A6852",
//     "companyVendorCode": null
// },
export const CompanyAndBranchPageColumnHeader = (
    freezeButton
  ) => [
    {
      field: "id",
      filterable: false,
      headerName: "ID",
      flex: 0.5,
      hide: true,
      headerAlign: "left",
    },
    {
      field: "companyName",
      headerName: "NAME",
      flex: 1.5,
      cellClassName: "bold-column--cell",
      headerAlign: "left",
    },
  
    {
      field: "companyCode",
      headerName: "CODE",
      flex: 1,
      headerAlign: "left",
    },
  
    // {
    //   field: "companyId",
    //   headerName: "COMPANY ID",
    //   flex: 1,
    //   headerAlign: "left",
    // },
    
    {
      field: "companyId",
      headerName: "ACTIONS",
      flex: 1,
      headerAlign: "left",
  
      filterable: false,
      renderCell: (params) =>
        freezeButton(params.row)
        // params.value === "Unfrozen" || params.value === null
        //   ? freezeButton(params.row)
        //   : unfreezeButton(params.row),
     
    },
  ];

export const freezeAccountButtonClick = (id) => {
  alert("button click");
  // Handle button click action here
};
